module.exports = __webpack_public_path__ + "img/order.5a8bd09f.png";